/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */


import UAParser from 'ua-parser-js';
import getWindow from './getWindow';

export class UserAgentParser {
    constructor({
        windowInterface,
        UAParserInterface,
    }) {
        this.window = windowInterface;
        this.UAParser = UAParserInterface;
    }

    buildString = (pieces) => {
        let output = '';

        if (!pieces.length) {
            return output;
        }

        pieces.forEach((piece) => {
            if (!piece) {
                return;
            }

            if (!output.length) {
                output = piece;
            } else {
                output = `${output} ${piece}`;
            }
        });

        return output;
    }

    getUAParser = (requestUserAgentString) => {
        const isSSR = this.window === null;

        if (isSSR && requestUserAgentString) {
            return new this.UAParser(requestUserAgentString);
        } else if (!isSSR) {
            return new this.UAParser();
        }

        return null;
    }

    parse = (requestUserAgentString) => {
        const parser = this.getUAParser(requestUserAgentString);

        // if on server and facet requestUserAgentString not passed,
        // return empty object
        if (!parser) {
            return {};
        }

        const ua = parser.getResult();

        // convert to top level strings for output in logger
        const output = {
            ua: ua.ua,
            browser: this.buildString([ua.browser.name, ua.browser.version]),
            engine: this.buildString([ua.engine.name, ua.engine.version]),
            os: this.buildString([ua.os.name, ua.os.version]),
            device: this.buildString([ua.device.model, ua.device.type, ua.device.vendor]),
        };

        return  output;
    }
}

const window = getWindow();
const userAgentParser = new UserAgentParser({
    windowInterface: window,
    UAParserInterface: UAParser,
});

export default userAgentParser;
